$(document).ready(function(e){
  // animate elements on scroll
  const $animationLineElement = $('.animation-element--line');
  const $animationElements = $('.animation-element');
  const $window = $(window);

  function checkIfInView() {
    if($(window).width() >= 800) {
      let windowHeight = $window.height();
      let windowTopPosition = $window.scrollTop();
      let windowBottomPosition = (windowTopPosition + windowHeight);
      //console.log({windowTopPosition},{windowBottomPosition},{windowHeight});
  // line steps section
      let windowCenter = windowHeight / 2 + windowTopPosition;
      let startPosition = $('.animation-start-pos').offset().left;
      let endPosition = $('.animation-end-pos').offset().left;
      let lineLenghth = endPosition - startPosition;

      let elementLHeight = $animationLineElement.parents('.steps-info').height();
      let elementLTopPosition = $animationLineElement.parents('.steps-info').offset().top;
      let elementLBottomPosition = (elementLTopPosition + elementLHeight);

      let factor = (windowCenter - ( elementLTopPosition - elementLHeight)) * 1.5;
      value = Math.min( factor, lineLenghth);

      if ((elementLBottomPosition >= windowTopPosition) && (elementLTopPosition <= windowBottomPosition)) {
        $animationLineElement.css({
            'width': value
        });
      }

  // persona section
      let gridTop = windowTopPosition + windowHeight * .1;
      let gridBottom = windowTopPosition + windowHeight * .7;
      $.each($animationElements, function() {
        let $element = $(this);
        let elementHeight = $element.height();
        let elementTopPosition = $element.offset().top;
        let elementBottomPosition = (elementTopPosition + elementHeight);

        //check to see if this current container is within viewport
        if ((gridTop < elementBottomPosition) && (gridBottom > elementTopPosition)) {
          $element.addClass('in-view animate');
        }
      });
    }

  }

  if($('body').hasClass('template-index')) {
    //checkIfInView();
    $window.resize(
      $.debounce(80, function() {
        checkIfInView();
      })
    );
    $window.trigger('scroll');


    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });

      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }


  }

  // on scroll, make header sticky
  $window.scroll(
    $.debounce(50, function() {
      if($(document).scrollTop() > 20 ) {
        $('.site-header').addClass('sticky');
        $('body').addClass('is-sticky');
      } else {
        $('.site-header').removeClass('sticky');
        $('body').removeClass('is-sticky');
      }
      if($('body').hasClass('template-index')) {
        checkIfInView();
      }
    })
  );

  // homepage - shop by category slider
  if($('.js-index-about-featured-slider').length) {
    $('.js-index-about-featured-slider').slick({
      arrows: true,
      infinite: false,
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      lazyLoad: 'ondemand',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  // mobile nav
  $('.js-toggle-nav').on('click', function(){
    $(this).toggleClass('active');
    $('#mobileNavWrapper').slideToggle(300);
    $(this).parents('.site-header').toggleClass('active');
    $('body').toggleClass('no-scroll');
  });

  //scroll to target div (in product page and footer TOP mobile button)
  $('.js-goto').on('click', function(e){
    e.preventDefault();
    let target = $(this).attr('href');
    if($(target).length > 0) {
      $('html, body').animate({
          scrollTop: $(target).offset().top - 20
      }, 700);
    }
  });
  $(".has-top-bar .mobile-nav-btn,.has-top-bar .mobile-nav-btn--des").click(function(){
      $(".announcement-bar").toggleClass("mob-nav-active");
  }); 
});